/* eslint-env jquery */

export default class ReactivationHelper {
  stripIDName = idWithHash => idWithHash.replace("#", "");

  setPageTitle = newTitle => $(document).prop("title", newTitle);

  scrollTo = (selector) => {
    if (selector === "TOP") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    document.querySelector(selector).scrollIntoView({ behavior: "smooth" });
  }

  upperCaseFirstLetter = word => word.substr(0, 1).toUpperCase() + word.substr(1);

  isEmpty = value => value === null || value === "";
}
